import {
  eqProps,
  curry,
  pipe,
  defaultTo,
  map,
  propEq,
  cond,
  always,
  T,
} from "ramda"

export const hasAnyCppVersionProgramCode = ({ programCode }) =>
  ["CPP1", "CPP2", "CPP3"].includes(programCode)

export const hasSppProgramCode = propEq("programCode", "SPP")

export const makeFormikSelectOptions = pipe(
  defaultTo([]),
  map(careerPath => ({
    value: careerPath.careerPathCode,
    label: careerPath.careerPathName,
  })),
)

// Merges a new and old career path object (from programHistory) into one, renaming the old one's keys
export const createCareerPathMapping = curry(
  (newCareerPath, oldCareerPath) => ({
    ...newCareerPath,
    isMapped: !eqProps("careerPathCode", oldCareerPath, newCareerPath),
    originalLabel: oldCareerPath.careerPathName,
    originalCode: oldCareerPath.careerPathCode,
    originalProgramCode: oldCareerPath.programCode,
  }),
)

export const CAREERPATH_GOLFOP = {
  careerPathCode: "GOLFOP",
  careerPathName: "Golf Operations",
}
export const CAREERPATH_EXECMGMT = {
  careerPathCode: "EXECMGMT",
  careerPathName: "Executive Management",
}
export const CAREERPATH_INSTRUCT = {
  careerPathCode: "INSTRUCT",
  careerPathName: "Teaching & Coaching",
}

// Takes a possibly old career path object (from programHistory) and returns a new object with the
// modern version of that career path, also includes the original
export const oldCareerPathToNewVersion = cond([
  [
    propEq("careerPathCode", "GOLFOP"),
    createCareerPathMapping(CAREERPATH_GOLFOP),
  ],
  [
    propEq("careerPathCode", "RETAIL"),
    createCareerPathMapping(CAREERPATH_GOLFOP),
  ],
  [
    propEq("careerPathCode", "EXECMGMT"),
    createCareerPathMapping(CAREERPATH_EXECMGMT),
  ],
  [
    propEq("careerPathCode", "GENMGMT"),
    createCareerPathMapping(CAREERPATH_EXECMGMT),
  ],
  [
    propEq("careerPathCode", "OWNLS"),
    createCareerPathMapping(CAREERPATH_EXECMGMT),
  ],
  [
    propEq("careerPathCode", "INSTRUCT"),
    createCareerPathMapping(CAREERPATH_INSTRUCT),
  ],
  [
    propEq("careerPathCode", "PLYRDEV"),
    createCareerPathMapping(CAREERPATH_INSTRUCT),
  ],
  [T, always(null)],
])
